import type { SchedulePriceQuoteRequest } from "@b2bportal/air-cfar-api";
import { Product } from "@b2bportal/purchase-api";
import { ParentState } from "@checkout/types";
import type { State } from "xstate";
import type {
  HtsAirCfarQuotedProduct,
  PartialParentContextWithHtsAirCfar,
} from "./types";

type CfarUpdateStateType = State<PartialParentContextWithHtsAirCfar>;
export type CfarUpdateStateWithoutValue = Pick<CfarUpdateStateType, "context">;

export const getCfarCartUpdateRequest = (
  state: CfarUpdateStateWithoutValue
) => {
  const offerId = getCfarOfferId(state) ?? "";
  const params: SchedulePriceQuoteRequest = {
    offerId,
  };

  return params;
};

export const getCfarOfferId = (
  state: CfarUpdateStateType | CfarUpdateStateWithoutValue
) => getHtsAirCfarCheckoutState(state).offerId;

export const getSelectedCfarOffer = (state: CfarUpdateStateWithoutValue) => {
  return getHtsAirCfarCheckoutState(state)?.selectedOffer;
};

export const getQuotedCfarProduct = (state: CfarUpdateStateWithoutValue) => {
  return state.context[ParentState.cartQuote].quoteBreakdown?.products
    .map((x) => x.product)
    .find(
      (product): product is HtsAirCfarQuotedProduct =>
        product.type === Product.HtsAirCfar
    );
};

const getHtsAirCfarCheckoutState = (state: CfarUpdateStateWithoutValue) => {
  return state.context[ParentState.htsAirCfar];
};
